import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "welcome-card" }
const _hoisted_2 = { class: "welcome-title" }
const _hoisted_3 = { class: "welcome-title-left-container" }
const _hoisted_4 = {
  key: 0,
  class: "card-title"
}
const _hoisted_5 = { class: "welcome-items-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item-container" }
const _hoisted_8 = { class: "item-content" }
const _hoisted_9 = { class: "welcome-item welcome-item-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, { src: $setup.iconQuestion }, null, 8, ["src"]),
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.list.length > 3 && !$setup.showAllRobotWelcomeItems)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "change-wrapper",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeBranchList()))
          }, [
            _createVNode(_component_Icon, { src: $setup.iconRefresh }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "welcome-item",
          onClick: ($event: any) => ($setup.handleContentListItemClick(item))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.content), 1)
          ])
        ], 8, _hoisted_6))
      }), 128)),
      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.longestContent), 1)
    ])
  ]))
}